import React, { useState, useEffect } from 'react';
import { Input, Button, Table, Tag, Divider, Typography } from 'antd';
import cookies from 'js-cookie';

import MainMenu from 'components/mainMenu';
import { toastError, toastSuccess } from 'utils/toastr';
import requestAPI from 'helpers/requestAPI';

import './domainsParser.scss';

const DomainsParser = () => {
	const [ query, setQuery ] = useState('');
	const [ dataParser, setDataParser ] = useState([]);
	const [ status, setStatus ] = useState('Finished')
	const [ tableLoading, setTableLoading ] = useState(false);
	const [ pagination, setPagination ] = useState({});
	let [ refreshAfterSeconds, updateRefreshAfter ] = useState(60);

	let startedData = cookies.get('domains_parser_started');
	let autoUpdateTableIntervalId = null;

	const updateData = (page = 0) => {
		const { task_ids, status } = JSON.parse(startedData)

		setTableLoading(true);
		const params = {
			routeParams: {
				route: 'v1/snapshots/download/lists'
			},
			useCustomURL: 'http://146.120.161.147:8000/',
			method: 'POST',
			data: {
				task_ids: task_ids,
				take: 10,
				skip: page * 10,
			}
		};

		requestAPI(params)
			.then((response) => {
				setPagination({
					...pagination,
					current: page + 1,
					pageSize: 10,
					total: response.data.total
				})

				const dataAdapter = response.data.data.map(task => ({
					id: task.id,
					key: task.id,
					query: task.site_domain,
					progress: `${task.processed} of ${task.total}`,
					link: [
						`${task.internal_server_url}/${task.site_domain}_${task.site_timestamp}.zip`,
						`${task.external_server_url}/${task.site_domain}_${task.site_timestamp}.zip`,
					],
					status: task.finished
				}))

				setDataParser(dataAdapter)

				if((response.data.finished && response.data.data.length) || status) {
					cookies.set(
						'domains_parser_started',
						JSON.stringify({
							task_ids: task_ids,
							status: true,
						}), {expires: 100 }
					)

					if (!!autoUpdateTableIntervalId) clearInterval(autoUpdateTableIntervalId)
					updateRefreshAfter(60)
					setStatus('Finished')

					return
				}

				setStatus('In progress')
			}).catch(error => {
				toastError(error?.response?.data?.detail || error)
		  })
		setTableLoading(false);
	};

	useEffect(
		() => {
			let timer = 60;
			if (startedData) {
				updateData();
				// eslint-disable-next-line
				autoUpdateTableIntervalId = setInterval(() => {
					if (timer === 0) {
						timer = 60;
						updateData();
					} else {
						timer--;
					}
					updateRefreshAfter(timer);
				}, 1000);

				return () => clearInterval(autoUpdateTableIntervalId);
			}
		},
		[ startedData ]
	);

	const { Title } = Typography;
	const { TextArea } = Input;

	const columns = [
		{
			title: 'Query',
			dataIndex: 'query',
			key: 'query',
			width: '250px'
		},
		{
			title: 'Files ready',
			dataIndex: 'progress',
			key: 'progress',
			width: '200px'
		},
		{
			title: 'Download links',
			dataIndex: 'link',
			key: 'link',
			width: '150px',
			render: (link) => {
				if (link) {
					return (
						<span>
							<a href={`http://${link[0]}`} download>
								Local
							</a>
							<Divider type="vertical" />
							<a href={`http://${link[1]}`} download>
								Global
							</a>
						</span>
					);
				}
			}
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: '70px',
			render: (status) => {
				return status ? <Tag color="green">{`${status}`}</Tag> : <Tag color="red">{`${status}`}</Tag>;
			}
		}
	];

	const onChangePagination = (pagination) => {
		setPagination({...pagination});
		updateData(pagination.current - 1)
	}

	const onClickStart = async () => {
		if (!query) {
			toastError('Add queries1');
			return;
		}

		if (startedData) {
			if (JSON.parse(startedData).status) {
				cookies.set('domains_parser_started', '', { expires: 0 });
			} else {
				toastError('Parser already works!');
				return;
			}
		}

		const params = {
			routeParams: {
				route: 'v1/snapshots/download'
			},
			useCustomURL: 'http://146.120.161.147:8000/',
			method: 'POST',
			data: {
				urls: query.split('\n')
			}
		}

		setPagination({
			page: 1,
			pageSize: 10,
			total: 10
		})

		await requestAPI(params)
			.then((resp) => {
				cookies.set(
					'domains_parser_started',
					JSON.stringify({
						task_ids: resp.data,
						status: false
					}), {expires: 100 }
				);

				toastSuccess('Parsing process started');
				setQuery('');
			})
			.catch((error) => {
				toastError(error?.response?.data?.detail || error)
			})
	}

	const onClickStop = () => {
		if (!startedData) {
			toastError('Nothing to stop!');
			return;
		}
	
		if (startedData && JSON.parse(startedData).status) {
			toastError('Parser already finished work!');
			return;
		}

		const { task_ids } = JSON.parse(startedData)

		const params = {
			routeParams: {
				route: 'v1/tasks/bulk'
			},
			useCustomURL: 'http://146.120.161.147:8000/',
			method: 'DELETE',
			data: {
				task_ids,
			}
		}

		requestAPI(params)
		.then(() => {
			cookies.set(
				'domains_parser_started',
				JSON.stringify({
					task_ids: task_ids,
					status: true,
				}), {expires: 100 }
			)
		})
		.catch(err => toastError(err?.response?.data?.detail?.msg || err))
	}

	const handleChangeTextArea = (e) => {
		setQuery(e.target.value);
	}

	return (
		<div>
			<MainMenu />
			<div className="domains-parser">
				<Title className="domains-parser__title">Domains Parser</Title>
				<p className="domains-parser__title__description">Если нужно выкачать шаблон сайта, тебе сюда</p>
				<div className="domains-parser__functional-area">
					<div className="domains-parser__functional-area__left-side">
						<TextArea
							id="text-area__domain-parser"
							value={query}
							onChange={handleChangeTextArea}
							rows={15}
							placeholder="Add key queries..."
						/>
						<div className="domains-parser__functional-area__left-side__buttons">
							<Button
								disabled={tableLoading}
								className="domains-parser__functional-area__left-side__buttons__start"
								type="primary"
								onClick={onClickStart}
							>
								Start
							</Button>
							<Button disabled={tableLoading} type="danger" onClick={onClickStop}>
								Stop
							</Button>
						</div>
					</div>
					<div className="domains-parser__functional-area__right-side">
						<div className="domains-parser__functional-area__right-side__wrapper">
							<div style={{ display: 'flex', justifyContent: 'space-between' }}>
								<span>Information:</span>
								<span>Status: <span className={`info-status ${status === 'Finished' ? 'done' : ''}`}>{status}</span></span>
								<span>Refresh after: {refreshAfterSeconds}</span>
							</div>
							<Table
								columns={columns}
								dataSource={dataParser}
								pagination={pagination}
								onChange={Object.keys(pagination).length ? onChangePagination : null}
								size={'small'}
								scroll={{ y: '264px', x: '600px' }}
								loading={tableLoading}
							/>
							<br />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DomainsParser;
